module.exports = __webpack_public_path__ + "img/qr.3e80bd77.png";